@import '../../theme/colors';
@import '../../theme/mixins';

.supportContainer {
  display: flex;
  flex-direction: column;
  position: relative;
  height: max-content;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 13px 0 30px;

    h1 {
      margin-right: 32px;
    }
  }

  .main {
    width: 100%;
    display: flex;

    .resultsCount {
      font-family: var(--font-family__heading);
      font-size: 12px;
      color: rgba(0, 0, 0, 0.87);
      padding-right: 17px;
      padding-bottom: 10px;
      white-space: nowrap;
      display: block;
    }

    .sidebarContainer {
      display: flex;
      flex-direction: column;
    }

    .sidebar {
      width: 251px;
      border: 1px solid $lightGrey;
      position: relative;
      transition: all 0.1s linear;
      flex: 1;

      &.collapsed {
        width: var(--sidebar-width);
      }

      & .collapsedFilters {
        visibility: hidden;
        opacity: 0;
        overflow: hidden;
        transition: all 0.1s linear;
      }

      .filters {
        overflow: hidden;
        visibility: visible;
        opacity: 1;
        transition: all 0.1s linear;

        .scrollTable {
          & > div:first-child {
            .filterSection:last-child {
              margin-bottom: 40px;
            }
          }
        }
      }

      .filterButtons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 45px;
        border-bottom: 2px solid $lightGrey;
        padding-right: 49px;
      }

      .icon {
        margin-top: 12px;
      }

      .topSection {
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid $lightGrey;

        .iconContainer {
          display: flex;
          align-items: center;
          font-family: var(--font-family__heading);
          font-size: 16px;
          font-weight: 500;
          color: $navy;
          padding-left: 16px;
          margin-top: 8px;

          span {
            margin-left: 6px;
          }
        }

        .collapsedIconContainer {
          @extend .iconContainer;
          justify-content: center;
          padding-left: 0;
          width: 100%;
        }

        .clearSection {
          display: flex;
          align-items: center;
          margin-right: 24px;
          margin-top: 8px;

          .filterCount {
            font-family: var(--font-family__heading);
            font-size: 13px;
            font-weight: 500;
            color: $white;
            background-color: $oceanBlue;
            border-radius: 6.5px;
            width: min-content;
            text-align: center;
            margin-left: 7px;
            padding: 0 6px;
            min-width: 16px;
          }
        }

        .collapsedClear {
          @extend .clearSection;
          display: none;
        }
      }

      .filterSection {
        border-bottom: 2px solid $lightGrey;
        padding: 17px 4px 30px 31px;
        margin: 0 10px;

        .title {
          font-family: var(--font-family__heading);
          font-size: 14px;
          font-weight: 400px;
          display: block;
          margin-bottom: 10px;
        }

        .checkboxForm {
          padding-bottom: 6px;
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;

          @include body1;
        }

        .checkbox {
          height: 16px;
          width: 16px;
          border-radius: 3px;
          border: 1px solid $neutral-300;
          color: transparent !important;
          background-color: transparent;
          padding: 0;
          margin-right: 6px;
          box-sizing: border-box;

          path {
            color: transparent;
          }
        }

        .checkbox:hover {
          border: 1px solid $seconaryActive;
        }

        .checkboxActive {
          @extend .checkbox;

          svg {
            width: 20px;
            height: 20px;
          }

          path {
            color: $oceanBlue;
          }
        }

        .checked {
          margin: 0 40px 10px 0;

          span {
            @include body1;
          }
        }
      }
    }

    .paginatedContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      // in conjunction with fix for firefox th/td z-index in table.scss
      .scrollTable > div {
        z-index: 101;
      }
    }
    .tableWrapper {
      flex: 1;
      margin-bottom: 10px;

      .sortContainer {
        display: flex;
        align-items: center;

        .bold {
          color: $navy;
          font-weight: 500;
        }

        .sortIcons {
          display: flex;
          flex-direction: column;
          position: relative;

          svg {
            position: absolute;
            cursor: pointer;
          }
        }
      }
      .refRow {
        color: $lightBlue;
        text-decoration: none;
        cursor: pointer;
      }

      .noResults {
        position: absolute;
        margin-left: 50px;
        font-size: 18px;
        font-weight: 500;
        color: $black;
      }

      .typeRow {
        max-width: 72px;
        padding-left: 38px;
      }

      .summaryRow {
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .paginationContainer {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .pageSelection {
        @include label1;
        text-align: end;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        margin-left: 10px;

        span {
          margin: 0 2px;
        }

        form {
          min-width: 17px;
          width: fit-content;
          max-width: 20px;
          height: 18px;
          margin: 0;
          margin-left: 2px;

          & > div:first-child {
            margin: 0;
          }

          input {
            @include label1;
            padding: 2px 3px !important;
            text-align: center;
          }
        }
      }

      .pageNumbers {
        display: flex;
        align-items: center;
        margin-left: 20px;

        i {
          color: $oceanBlue;
          font-size: 20px;
        }

        div {
          @include body2;
          width: 21px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        span {
          cursor: pointer;
        }

        .activePage {
          background-color: $oceanBlue;
          color: $white;
        }
      }
    }

    .pageAmount {
      cursor: pointer;
    }

    .pageAmountActive {
      @extend .pageAmount;
      background-color: $oceanBlue;
      color: $white;
      width: min-content;
      height: min-content;
      text-align: center;
      font-family: var(--font-family__body);
      font-size: 12px;
      padding: 2px;
    }
  }
}

.circularProgress {
  position: fixed;
  top: 60vh;
  left: 50%;
}
